export default "<p>service works!</p>\n";